import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ButtonComponent } from 'app/shared/components/button/button.component';
import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';
import { SubscriptionModalComponent } from 'app/components/subscription-modal/subscription-modal.component';

import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';
import { IUserSubscription } from 'app/interfaces/profile.interfaces';
import { IButtonConfig } from 'app/shared/interfaces/button.interfaces';

import { ESubscriptionState } from 'app/enums/purchases.enums';
import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { EButtonSizes, EButtonTypes } from 'app/shared/enums/button.enums';

@Component({
  selector: 'stxt-purchases-subscription-card',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, ButtonComponent],
  templateUrl: './purchases-subscription-card.component.html',
  styleUrl: './purchases-subscription-card.component.scss'
})
export class PurchasesSubscriptionCardComponent {
  @Input() subscriptionItem: IUserSubscription;
  @Output() openPayment: EventEmitter<IUserSubscription> = new EventEmitter<IUserSubscription>();
  public arrowRightIcon: ISvgConfig = { name: 'arrow_right', fill: ESvgTypes.None };
  public SubscriptionState = ESubscriptionState;
  public resubscribeBtn: IButtonConfig = {
    text: 'Resubscribe',
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Small
  };

  constructor(private modal: NgbModal) {}

  openSubscriptionModal(): void {
    const modalRef = this.modal.open(SubscriptionModalComponent);
    if (this.subscriptionItem) {
      modalRef.componentInstance.creatorData = this.subscriptionItem.creator;
      modalRef.componentInstance.subscriptionPrice = this.subscriptionItem.creator.sub_plan.price;
    }
    modalRef.closed.subscribe({
      next: res => {
        if (res === 'payment') {
          this.openPayment.emit(this.subscriptionItem);
        }
      }
    });
  }
}
